import { render, staticRenderFns } from "./Scaffolding.vue?vue&type=template&id=7aa6e376"
import script from "./Scaffolding.vue?vue&type=script&lang=js"
export * from "./Scaffolding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports